import React from 'react';

const SuperAdminProfile = () => {
    return (
        <div>
            <h2 style={{ fontSize: "22px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
            Is it possible to update profile details ?
            </h2>

            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Step-1: Select the profile in the sidebar and click it, then you will get into the profile page.
            </h3>
            {/* <p>Note: Click the profile of the dashboard, select it, and enter the details.</p> */}
            <img src=" https://res.cloudinary.com/danfpnuui/image/upload/v1740681407/WhatsApp_Image_2025-02-28_at_12.05.52_AM_gak7z5.jpg " alt="Step 1" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />

            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Step-2: Select the Profile details and click the Edit button to Update User Details
            </h3>
            <p>Tip: Enter your details given there as required.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1740681116/WhatsApp_Image_2025-02-27_at_10.29.55_PM_wpccro.jpg" alt="Step 2" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />

            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Step-3: Select Educational Details
            </h3>
            <p>Note: Click the add button, then fill in your education details.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1740681490/WhatsApp_Image_2025-02-27_at_10.29.54_PM_mdpkf8.jpg" alt="Step 3" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />

            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Step-4: Select Work Experience and click the Add button to enter job details.
            </h3>
            <p>Note: Enter Your Job Title, Company Name, Start Date, End Date, and Description.</p>
            <img src="https://res.cloudinary.com/danfpnuui/image/upload/v1740681681/WhatsApp_Image_2025-02-27_at_10.29.52_PM_1_opi68v.jpg" alt="Step 4" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />

            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                Step-5: Select Skill Set and click the Add button to enter Skill Details.
            </h3>
            <p>Note: Enter Your Skill Name, Rating / 100, Version, then click Save.</p>
            <p>Tip: If you add your details, it will be helpful for your experience.</p>
            <img src=" https://res.cloudinary.com/danfpnuui/image/upload/v1740681739/WhatsApp_Image_2025-02-27_at_10.29.54_PM_1_dtseps.jpg" alt="Step 5" style={{ width: "60%", height: "auto", marginBottom: "20px" }} />

        
        </div>     
    );
};

export default SuperAdminProfile;
